<template>
  <common-page
    ref="commonPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :table-options="tableOptions"
    :search-items="searchItems"
    :form-items="formItems"
  />
</template>
<script>
export default {
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'pharmacy/pharmacy/pharmacy/nutraceuticals',
      // Web路径
      webPath: 'pharmacy/pharmacy/pharmacy/nutraceuticals',
      tableOptions: ['details', 'edit', 'filter'],
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "name",
              name: "名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "effectiveSign",
              name: "类型标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "5", value: "产品" }
                ]
              }
            },
            {
              code: "pharmacyCode",
              span: 6,
              name: "药房编码",
              config: {
                edit: false
              }
            },
            {
              code: "pharmacyName",
              name: "药房名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            }
          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "code",
          name: "编码",
          type: "text",
          span: 6,
          config: {
            edit: false,
            rules: [
              { required: true, message: '请输入编码', trigger: 'blur' }
            ]
          }
        },
        {
          code: "name",
          name: "名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            rules: [
              { required: true, message: '请输入名称', trigger: 'blur' }
            ]
          }
        },
        {
          code: "typeSign",
          name: "类型标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            defaultValue: '5',
            options: [
              { key: "5", value: "产品" }
            ]
          }
        },
        {
          code: "pharmacyCode",
          span: 6,
          name: "药房编码",
          config: {
            edit: false
          }
        },
        {
          code: "pharmacyName",
          name: "药房名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "materielCode",
          span: 6,
          name: "物料编码",
          type: "text",
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "materielName",
          name: "物料名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "materielDescribe",
          name: "物料描述",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "unitPrice",
          name: "销售定价",
          span: 6,
          type: "number",
          search: true,
          config: {
            edit: false,
            width: 200
          }
        },
        {
          code: "retailPrice",
          name: "建议零售价",
          span: 6,
          type: "number",
          search: true,
          config: {
            edit: false
          }
        },
        {
          code: "effectiveSign",
          name: "有效标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "无效" },
              { key: "1", value: "有效" }
            ]
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true,
                rules: [
                  { required: true, message: '请输入编码', trigger: 'blur' }
                ]
              }
            },
            {
              code: "name",
              name: "名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true,
                rules: [
                  { required: true, message: '请输入名称', trigger: 'blur' }
                ]
              }
            },
            {
              code: "typeSign",
              name: "类型标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                disabled: true,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "1", value: "中成药" },
                  { key: "2", value: "西药" },
                  { key: "3", value: "饮片" }
                ]
              }
            },
            {
              code: "pharmacyCode",
              span: 6,
              name: "药房编码",
              type: "popup",
              config: {
                url: "base/user/user/pharmacy",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: true,
                require: true
              },
              handleEvent: {
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("pharmacyName", row.name)
                  this.$refs.commonPage.updateFormData("pharmacyId", row.id)
                }
              }
            },
            {
              code: "pharmacyName",
              name: "药房名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "materielCode",
              span: 6,
              name: "物料编码",
              type: "popup",
              config: {
                url: "base/dictionary/medicinedic/materiel",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: true,
                rules: [
                  { required: true, message: '请选择门店物料', trigger: 'change' }
                ]
              },
              handleEvent: {
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("materielName", row.name)
                  this.$refs.commonPage.updateFormData("clinicMaterielId", row.id)
                  this.$refs.commonPage.updateFormData("materielId", row.id)
                  this.$refs.commonPage.updateFormData("iotCode", row.iotCode)
                }
              }
            },
            {
              code: "materielName",
              name: "物料名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "materielDescribe",
              name: "物料描述",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "unitPrice",
              name: "销售定价",
              span: 6,
              type: "number",
              search: true,
              config: {
                edit: false
              }
            },
            {
              code: "retailPrice",
              name: "建议零售价",
              span: 6,
              type: "number",
              search: true,
              config: {
                edit: false
              }
            },
            {
              code: "effectiveSign",
              name: "有效标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "0", value: "无效" },
                  { key: "1", value: "有效" }
                ]
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
